const getMediaUrls = featuredHeader => {
  const { web, app } = featuredHeader || {};

  return {
    mobile: {
      imageUrl: app?.imageUrl || null,
      videoUrl: app?.videoAssetId || null
    },
    desktop: {
      imageUrl: web?.imageUrl || null,
      videoUrl: web?.videoAssetId || null
    }
  };
};

export default getMediaUrls;
